import { TournamentState } from '@ps/web-poker-tile-mappers';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import useGetMessages from '../../../hooks/useGetMessages';
import { usePokerSundayMillionWidget } from '../../../model';
import Skeleton from '../../Skeleton/Skeleton';

import EventCountdown from './EventCountdown';
import styles from './EventMessages.scss';
import EventTime from './EventTime';
import EventTimer from './EventTimer';

const sx = { display: 'inline-block', width: 300 };

const EventMessages: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const state = useSelector(widgetSelect.getTournament)?.formattedState;
  const isHydrated = useSelector(widgetSelect.isHydrated);
  const isLoading = useSelector(widgetSelect.isLoading);
  const { line1, line1Alt, line2 } = useGetMessages();

  const lateReg = { [styles.lateReg]: state === TournamentState.LATE_REGISTRATION };
  const line1Countdown = false; // state === TournamentState.PAUSED; POKER-14214 removed MVP; return post-MVP
  const line1Timer = [TournamentState.LATE_REGISTRATION, TournamentState.RUNNING].includes(state);
  const showSkeleton = !isHydrated || isLoading;

  return (
    <div className={styles.root}>
      <div className={styles.line1}>
        {showSkeleton ? (
          <Skeleton sx={sx} />
        ) : (
          <>
            {line1} {line1Timer && <EventTimer />} {line1Countdown && <EventCountdown />}
          </>
        )}
      </div>
      <div className={classNames(styles.line1Alt, { ...lateReg })}>
        {showSkeleton ? (
          <Skeleton sx={sx} />
        ) : (
          <>
            {line1Alt} <EventTime />
          </>
        )}
      </div>
      <div className={classNames(styles.line2, { ...lateReg })}>
        {showSkeleton ? <Skeleton sx={{ ...sx, width: 250 }} /> : line2}
      </div>
    </div>
  );
};
export default EventMessages;
